/** @jsxImportSource react/jsx-runtime */
/** @jsxRuntime classic */

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../assests/authLogo.png";
import { paymentOptionList } from "../../utils/general";
// Create styles
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  cellfooter: {
    width: "100%",
  },
  cell: {
    width: "48%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell4: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell5: {
    width: "40%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell6: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  tc: {
    textAlign: "center",
  },
  tr: {
    textAlign: "right",
  },
  headerCell: {
    fontWeight: "bold",
  },
  headText: {
    margin: 4,
  },
  page: {
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: "#fff",
    padding: 30,
    margin: 12,
    marginRight: 10,
  },
  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 10,
  },
  col: {
    width: "50%",
  },
  col2: {
    width: "100%",
  },
  section: {
    fontSize: 10,
  },
  imgstyle: {
    width: "50%",
  },
  textstyle: {
    color: "#032037d4",
    fontSize: 12,
  },
  topHeader: {
    fontSize: 12,
  },
  textstyleheader: {
    color: "#032037d4",
  },
  textstyleheader1: {
    color: "#032037d4",
  },
  textstyleheader2: {
    color: "black",
    marginBottom: 9,
  },
  font2: {
    fontSize: 12,
    fontWeight: "bold",
  },
  color1: {
    backgroundColor: "#1c90bed6",
    color: "white",
  },
  textstyle1: {
    color: "#005598",
    fontSize: 15,
    fontWeight: "bold",
    margingLeft: 12,
  },

  section2: {
    backgroundColor: "#003e6a",
    color: "white",
    fontSize: 13,
    fontWeight: "bold",
    padding: 5,
  },
  mt: { marginTop: -5 },
  mt1: { marginTop: 0 },
  mb: { marginBottom: 30 },
  mb1: { marginBottom: 0 },
  mb2: { marginBottom: 12 },
  mb3: { marginBottom: 10 },
  ml: { marginLeft: 6 },
  ml1: { marginLeft: 30 },
  mr: { marginRight: 6 },
  section3: {
    width: "100%",
    color: "#005598",
    fontSize: 15,
    fontWeight: "bold",
    margingLeft: 10,
  },
  textBold: {
    fontWeight: 500,
    color: "#005598",
    fontSize: 15,
    fontWeight: "bold",
  },
  textBold2: {
    color: "#000000b8",
    fontSize: 12,
  },
  textBold1: {
    fontSize: 12,
    // fontWeight: "bolder",
    color: "#000000",
  },
  ht: {
    height: "26%",
    maxHeight: "26%",
  },
});

function convertCurrencyFormat(inputAmount) {
  // Check if the inputAmount is a valid number
  if (typeof inputAmount !== "number" || isNaN(inputAmount)) {
    return "Invalid input amount";
  }

  // Determine if the inputAmount is negative
  const isNegative = inputAmount < 0;

  // Convert the absolute value of the numeric amount into the desired format
  const formattedAmount = Math.abs(inputAmount).toFixed(2);

  // Replace the decimal separator (dot) with a comma
  // and the thousands separator (comma) with a space
  let result = `${formattedAmount
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} $`;

  // Add parentheses for negative amounts
  if (isNegative) {
    result = `(${result})`;
  }

  return result;
}

// Create Payment Component
const Payments = ({ data }) => (
  <Document>
    {Object.keys(data).length !== 0 && (
      <Page size="A4" style={styles.page}>
        <View style={[styles.row, styles.mb]}>
          <View style={[styles.col]}>
            <View style={[styles.section]}>
              <Image src={logo} style={styles.imgstyle} />
            </View>
            <View style={[styles.section, styles.ml1]}>
              <Text style={[styles.textstyleheader1, styles.topHeader]}>
                200, avenue de la Cathédrale Winnipeg
              </Text>
            </View>
            <View style={[styles.section, styles.ml1]}>
              <Text style={[styles.textstyleheader, styles.topHeader]}>
                (Manitoba) R2H 0H7 1-204-233-0210
              </Text>
            </View>

            <View style={[styles.section, styles.ml1]}>
              {" "}
              <Text style={styles.topHeader}>finances@ustboniface.ca</Text>
            </View>
            <View style={[styles.section, styles.ml1]}>
              {" "}
              <Text style={[styles.textstyleheader2, styles.topHeader]}>
                Numéro d'entreprise : 106953110
              </Text>
            </View>
          </View>
          <View style={styles.col}>
            <View style={[styles.headerCell]}>
              <Text style={[styles.textstyle1, styles.ml]}>Reçu</Text>
            </View>
            <View style={[styles.container, styles.headText, styles.font2]}>
              <View style={[styles.cell, styles.headerCell, styles.color1]}>
                <Text>Reçu</Text>
              </View>
              <View style={[styles.cell, styles.headerCell]}>
                <Text>{data.ses_paymentno}</Text>
              </View>
            </View>
          </View>
        </View>

        {/*second part  */}

        <View style={[styles.row, styles.mb]}>
          <View style={[styles.mb3]}>
            <Text style={[styles.textBold]}>Information estudiantine</Text>
          </View>
          <View style={styles.row}>
            <View style={styles.col}>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Nom :</Text>{" "}
                  <Text style={styles.textBold2}> {data.ses_studentname}</Text>
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>N° d’étudiant :</Text>{" "}
                  <Text style={styles.textBold2}> {data?.ses_student}</Text>{" "}
                </Text>
              </View>
              <View style={[styles.section]}>
                <Text>
                  <Text style={styles.textBold1}>Adresse :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {data.address1_line1}, {""}
                    {data.address1_line2}
                  </Text>{" "}
                </Text>
              </View>
              <View style={[styles.section, styles.mb2]}>
                <Text style={styles.textBold2}>
                  {data.address1_city} - {data.address1_stateorprovince}{" "}
                </Text>{" "}
              </View>
              <View style={[styles.section, styles.mb2]}>
                <Text>
                  <Text style={styles.textBold1}>Courriel :</Text>{" "}
                  <Text style={styles.textBold2}> {data.emailaddress1}</Text>{" "}
                </Text>
              </View>

              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>N° de reçu :</Text>{" "}
                  <Text style={styles.textBold2}> {data?.ses_paymentno}</Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Date de paiement :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {data.ses_paymentdate != null
                      ? moment(data.ses_paymentdate).format("YYYY/MM/DD")
                      : null}
                  </Text>{" "}
                </Text>
              </View>
            </View>
            <View style={styles.col}>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Somme totale :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {convertCurrencyFormat(data.ses_paymentamt)}
                  </Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Méthode de paiement :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {paymentOptionList(
                      data[
                        "ses_paymenttype@OData.Community.Display.V1.FormattedValue"
                      ],
                      true,
                    )}
                  </Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Date de vérification :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {data.usb_checkdate != null
                      ? moment(data.usb_checkdate).format("YYYY/MM/DD")
                      : null}
                  </Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>N° de vérification :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {data?.ses_checkpromocc}
                  </Text>{" "}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* third part */}
        <View style={styles.row}>
          <View style={[styles.mb3]}>
            <Text style={[styles.textBold]}>Information de facturation</Text>
          </View>
          <View style={styles.row}>
            <View style={styles.col}>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>N° :</Text>{" "}
                  <Text style={styles.textBold2}> {data.invoicenumber}</Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Date :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {data.ses_invoicedate != null
                      ? moment(data.ses_invoicedate).format("YYYY/MM/DD")
                      : null}
                  </Text>{" "}
                </Text>
              </View>
              <View style={[styles.section, styles.mb2]}>
                <Text>
                  <Text style={styles.textBold1}>Terme :</Text>{" "}
                  <Text style={styles.textBold2}>
                    {" "}
                    {
                      data[
                        "_ses_term_value@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </Text>{" "}
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  <Text style={styles.textBold1}>Note :</Text>{" "}
                  <Text style={styles.textBold2}> {data?.usb_portalnotes}</Text>{" "}
                </Text>
              </View>
            </View>
            <View style={styles.col}></View>
          </View>
        </View>
      </Page>
    )}
  </Document>
);

export default Payments;
